
/* injects from baggage-loader */

'use strict';

export default class IssuerOnboardingRepresentationsController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
